const { attachDocument } = require('api/Attachments');
const { default: setMultipleQueriesData } = require('../setMultipeQueriesData');

export default async function setSelectedAppointment({
  appointment,
  document,
  queryClient,
  navigate
}) {
  if (document?.appointment_id === appointment?.id) return;
  const params = {
    ...document,
    appointmentId: appointment ? appointment?.id : null
  };

  const { data } = await attachDocument(navigate, params);

  let newAttachment = {};

  await setMultipleQueriesData(queryClient, ['chart-documents', 'practice-documents'], (old) => {
    return {
      ...old,
      documents: old?.documents?.map((item) => {
        if (item?.id === document?.id) {
          const newItem = {
            ...item,
            appointment_id: data?.id,
            date_of_service: data?.starts_at
          };

          newAttachment = { ...newItem, old_appointment_id: item?.appointment_id };

          return newItem;
        } else {
          return item;
        }
      })
    };
  });

  if (document?.appointment_id) {
    if (appointment && document?.appointment_id !== appointment?.id) {
      await queryClient.setQueriesData(
        ['attachment-documents', document?.appointment_id?.toString()],
        (old) => {
          return {
            ...old,
            documents: old?.documents?.filter((item) => item?.id !== document?.id)
          };
        }
      );
    }
  }

  await queryClient.setQueriesData(
    ['attachment-documents', appointment?.id?.toString() || document?.appointment_id?.toString()],
    (old) => {
      if (!old?.documents?.find((item) => item?.id === document?.id) && appointment) {
        return {
          ...old,
          documents: [newAttachment, ...(old?.documents || [])]
        };
      } else if (old?.documents?.find((item) => item?.id === document?.id) && !appointment) {
        return {
          ...old,
          documents: old?.documents?.filter((item) => item?.id !== document?.id)
        };
      } else {
        return old?.documents?.map((item) => {
          if (item?.id === document?.id) {
            return {
              ...item,
              appointment_id: data?.id,
              date_of_service: data?.starts_at
            };
          } else {
            return item;
          }
        });
      }
    }
  );
}
